import { useMemo } from "react";

import { useRunningTurnsStore } from "@/features/agents/runningTurnsStore";
import { scopeKey } from "@/features/agents/types";
import { useAgentSpecs } from "@/features/agents/useAgentSpecs";

import { useAgentAttention } from "../context/AgentAttentionProvider";
import { agentStackSeeds } from "../faces";

/** The faces for the Agents button and the menu header, from one source. */
export function useAgentStackSeeds(): string[] {
  const { items } = useAgentAttention();
  const running = useRunningTurnsStore((s) => s.turns);
  const { practiceScope } = useAgentSpecs();
  const practiceSeed = practiceScope ? scopeKey(practiceScope) : null;
  return useMemo(
    () =>
      agentStackSeeds({
        waiting: items,
        running,
        recent: [],
        practiceSeed
      }),
    [items, running, practiceSeed]
  );
}
